// Utility functions specific to the app not to framework
$.On('click', '[js-action-clear-local-storage]', function() {
  State.clearStorage();
  console.log("Clearing local storage...")
});